// src/ui/PerlTextField.jsx
import React from "react";
import { TextField } from "@mui/material";

export default function PerlTextField({
  label,
  value,
  onChange,
  placeholder,
  disabled = false,
  multiline = false,
  rows,
  type = "text",
  showLabel = true,
  ...props
}) {
  return (
    <TextField
      label={showLabel && label ? label : undefined}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      multiline={multiline}
      rows={rows}
      type={type}
      fullWidth
      {...props}
    />
  );
}
